/* eslint-disable */
import axios from 'axios';
import { store } from '../store';


function fmtFileHistory(file) {
  return {
    activated: file.activated,
    planYear: file.plan_year,
    familyID: file.file_family_id,
    carrierID: file.carrier_id,
    fileName: file.file_name,
    fileFamilyID: file.file_family_id,
    fileFamilyName: file.file_family_name,
    fileNameID: file.rts_file_name_id,
    processingDate: file.processing_date,
    totalAgentsCount: file.total,
    newAgentsCount: file.activated,
    updatedAgentsCount: file.changed,
    deactivatedAgentsCount: file.deactivated,
    errorCount: file.error,
    unchangedCount: file.nochange,
  };
}

function fmtPattern(pattern) {
  return {
    created: pattern.created,
    updated: pattern.modified,
    pattern: pattern.pattern,
  };
}

function fmtFamily(pattern) {
  return {
    created: pattern.file_source_family.created,
    updated: pattern.file_source_family.modified,
    familyID: pattern.file_source_family.id,
    carrierID: pattern.file_source_family.carrier_id,
    name: pattern.file_source_family.name,
  };
}

function fmtDeactivation(rec) {
  return {
    cpcID: rec.cpc_id,
    user_id: rec.userID,
    username: rec.username,
    firstName: rec.first_name,
    lastName: rec.last_name,
    npn: rec.npn,
    planYear: rec.plan_year,
    fileFamilyID: rec.FileFamilyID,
    carrierID: rec.carrier_id,
    fileNameID: rec.rts_file_name_id,
    lastFileSource: rec.last_file_source,
  };
}

export function getFileHistory({ startDate, endDate, familyID, carrierID }) {
  const { token } = store.getState().auth;

  const params = {
    change_date_start: startDate,
    change_date_end: endDate,
    carrier_id: carrierID,
    file_family_id: familyID,
  };

  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/rtsfiles/history/`,
    headers: { Authorization: `Token ${token}` },
    params,
  }).then(({ data }) => {
    return data.map(f => fmtFileHistory(f));
  });
};

export function getFilePatterns() {
  const { token } = store.getState().auth;

  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/rtsfiles/family/`,
    headers: { Authorization: `Token ${token}` },
  }).then(({ data }) => {
    const families = {};
    data.forEach(p => {
      const familyID = p.file_source_family.id;
      if (families[familyID]) { families[familyID].patterns.push(fmtPattern(p)); }
      else { families[familyID] = { ...fmtFamily(p), patterns: [ fmtPattern(p) ] }; }
    });
    return Object.values(families);
  });
};

export function getFileDetails({
  planYear,
  fileFamilyID,
  carrierID,
  fileNameID,
  page = 1,
  pageSize = 30,
  listType = 'deactivations',
}) {
  const { token } = store.getState().auth;

  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/rtsfiles/${listType}/`,
    headers: { Authorization: `Token ${token}` },
    params: {
      plan_year: planYear,
      file_family_id: fileFamilyID,
      carrier_id: carrierID,
      file_name_id: fileNameID,
      size: pageSize,
      page,
    },
  }).then(({ data }) => ({
    page: data.Page,
    totalCount: data.TotalCount,
    totalPages: data.TotalPages,
    pageSize,
    results: (data.Results || []).map(r => fmtDeactivation(r)),
  }));
}
